import React from "react"
import moment from "moment"
import { formatSeminarSchedule } from "./PastSeminarCard"

export const UpcomingSeminarSection = ({ seminar }) => {
    if (!seminar) return null
    const scheduleText = formatSeminarSchedule(seminar)
    const hasKeyTopics = Boolean(seminar.keyTopics && seminar.keyTopics.trim())

    return (
        <section
            aria-labelledby={`upcoming-seminar-${seminar.seminarID}`}
            className="row g-0 align-items-stretch overflow-hidden rounded shadow-sm mb-4 mb-lg-5"
            style={{ backgroundColor: "#f5f7f8" }}
        >
            <div className="col-lg-7 p-4 p-lg-5">
                <span
                    className="badge rounded-pill px-3 py-2 mb-3"
                    style={{ backgroundColor: "#cd9e53", color: "#16374e" }}
                >
                    Upcoming seminar
                </span>
                <h2
                    id={`upcoming-seminar-${seminar.seminarID}`}
                    className="fw-bold mb-3"
                    style={{ color: "#16374e" }}
                >
                    {seminar.title}
                </h2>
                <p className="fw-semibold mb-3" style={{ color: "#514d4d" }}>
                    {seminar.subTitle && <span className="d-block mb-1 text-uppercase">{seminar.subTitle}</span>}
                    {scheduleText && <span className="fw-bold text-dark">{scheduleText}</span>}
                </p>

                <div className="mb-3" style={{ color: "#333", textAlign: "justify" }}>
                    <p>{seminar?.description ? seminar?.description : "-"}</p>
                </div>

                <h3 className="h5 fw-bold mt-4 mb-3" style={{ color: "#16374e" }}>
                    Key topics
                </h3>
                {hasKeyTopics ? (
                    /<[a-z][\s\S]*>/i.test(seminar.keyTopics) ? (
                        <div className="mb-4" dangerouslySetInnerHTML={{ __html: seminar.keyTopics }} />
                    ) : (
                        <ul className="row row-cols-1 row-cols-md-2 g-2 ps-4 mb-4">
                            {seminar.keyTopics
                                .split(/[\r\n]+/)
                                .map((t) => t.trim())
                                .filter(Boolean)
                                .map((topic, index) => (
                                    <li key={index} className="pe-3">
                                        {topic}
                                    </li>
                                ))}
                        </ul>
                    )
                ) : (
                    <div className="text-muted mb-4">-</div>
                )}

                <div className="d-flex flex-wrap gap-2">
                    {seminar.registerLink && (
                        <a
                            className="btn fw-semibold px-4 py-2"
                            href={seminar.registerLink}
                            target="_blank"
                            rel="noreferrer"
                            style={{ backgroundColor: "#16374e", color: "#fff" }}
                        >
                            Register for the seminar
                        </a>
                    )}
                </div>
            </div>

            <div
                className="col-lg-5 d-flex align-items-center justify-content-center p-3 p-lg-4"
                style={{ backgroundColor: "#16374e" }}
            >
                <img
                    src={seminar.sidePhotoPath || seminar.sidePicView || seminar.seminarPhotoPath || seminar.seminarPicView}
                    alt={seminar.title || "MILSO Academy upcoming seminar announcement"}
                    onError={(e) => {
                        e.currentTarget.onerror = null
                        e.currentTarget.src = "/Static/Assets/Img/Seminar_Img.jpeg"
                    }}
                    className="img-fluid rounded"
                    style={{
                        width: "100%",
                        maxHeight: "620px",
                        objectFit: "contain",
                        boxShadow: "8px 8px #cd9e53",
                    }}
                />
            </div>
        </section>
    )
}

